/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_What_Is_Json_S1_P1Inputs */

const en_guide_what_is_json_s1_p1 = /** @type {(inputs: Guide_What_Is_Json_S1_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`At its core, JSON is built on two universal data structures: <strong>objects</strong> (collections of key-value pairs) and <strong>arrays</strong> (ordered lists of values). These simple building blocks can represent complex, nested data structures that are easy for both humans to read and machines to parse.`)
};

const ko_guide_what_is_json_s1_p1 = /** @type {(inputs: Guide_What_Is_Json_S1_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON의 핵심은 두 가지 보편적인 데이터 구조로 이루어져 있습니다: <strong>객체</strong>(키-값 쌍의 모음)와 <strong>배열</strong>(정렬된 값의 목록). 이 단순한 구성 요소로 복잡하고 중첩된 데이터 구조를 표현할 수 있으며, 사람이 읽기에도 기계가 파싱하기에도 쉽습니다.`)
};

const ja_guide_what_is_json_s1_p1 = /** @type {(inputs: Guide_What_Is_Json_S1_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSONの核心には、2つの普遍的なデータ構造があります：<strong>オブジェクト</strong>（キーと値のペアの集合）と<strong>配列</strong>（値の順序付きリスト）です。これらのシンプルな構成要素で、人間が読みやすく機械が解析しやすい複雑なネストされたデータ構造を表現できます。`)
};

/**
* | output |
* | --- |
* | "At its core, JSON is built on two universal data structures: <strong>objects</strong> (collections of key-value pairs) and <strong>arrays</strong> (ordered l..." |
*
* @param {Guide_What_Is_Json_S1_P1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_what_is_json_s1_p1 = /** @type {((inputs?: Guide_What_Is_Json_S1_P1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_What_Is_Json_S1_P1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_what_is_json_s1_p1(inputs)
	if (locale === "ko") return ko_guide_what_is_json_s1_p1(inputs)
	return ja_guide_what_is_json_s1_p1(inputs)
});